import navigateToNextCarsOnboardingPageAction from "@actions/navigateToNextCarsOnboardingPageAction"
import carsOnboardingLoader from "@loaders/carsOnboardingLoader"
import SubscriptionCountPage from "@pages/onboarding/SubscriptionCountPage"
import { Navigate, Outlet } from "react-router-dom"
import CarsAlmostTherePage from "./CarsAlmostTherePage"
import CarsBiggestPainPage from "./CarsBiggestPainPage"
import CarsBlockerPage from "./CarsBlockerPage"
import CarsCommitmentPage from "./CarsCommitmentPage"
import CarsCurrentSetupPage from "./CarsCurrentSetupPage"
import CarsDataConfidencePage from "./CarsDataConfidencePage"
import CarsDecisionMomentPage from "./CarsDecisionMomentPage"
import CarsDoingGreatPage from "./CarsDoingGreatPage"
import CarsExperimentingPage from "./CarsExperimentingPage"
import CarsFutureOutcomePage from "./CarsFutureOutcomePage"
import CarsGarageSizePage from "./CarsGarageSizePage"
import CarsMistakeCostPage from "./CarsMistakeCostPage"
import CarsMustTrackPage from "./CarsMustTrackPage"
import CarsShareWithWhoPage from "./CarsShareWithWhoPage"
import CarsStartHerePage from "./CarsStartHerePage"
import CarsSuccessSignalPage from "./CarsSuccessSignalPage"
import CarsTimeSpentPage from "./CarsTimeSpentPage"
import CarsTopPriorityPage from "./CarsTopPriorityPage"
import CarsUpdateFrequencyPage from "./CarsUpdateFrequencyPage"
import CarsWhyCarsProfilePage from "./CarsWhyCarsProfilePage"

const action = navigateToNextCarsOnboardingPageAction

const onboardingCarsRoutes = [
  {
    path: "/onboarding/cars",
    element: <Outlet />,
    loader: carsOnboardingLoader,
    children: [
      {
        element: <Navigate to={`startHere${window.location.search}`} replace />,
        index: true,
      },
      {
        action,
        element: <CarsStartHerePage />,
        path: "startHere",
      },
      {
        action,
        element: <CarsCurrentSetupPage />,
        path: "currentSetup",
      },
      {
        action,
        element: <CarsGarageSizePage />,
        path: "garageSize",
      },
      {
        action,
        element: <CarsTopPriorityPage />,
        path: "topPriority",
      },
      {
        action,
        element: <CarsWhyCarsProfilePage />,
        path: "whyCarsProfile",
      },
      {
        action,
        element: <CarsBiggestPainPage />,
        path: "biggestPain",
      },
      {
        action,
        element: <CarsUpdateFrequencyPage />,
        path: "updateFrequency",
      },
      {
        action,
        element: <CarsDataConfidencePage />,
        path: "dataConfidence",
      },
      {
        action,
        element: <CarsMustTrackPage />,
        path: "mustTrack",
      },
      {
        action,
        element: <CarsShareWithWhoPage />,
        path: "shareWithWho",
      },
      {
        action,
        element: <CarsDecisionMomentPage />,
        path: "decisionMoment",
      },
      {
        action,
        element: <CarsExperimentingPage />,
        path: "experimenting",
      },
      {
        action,
        element: <CarsDoingGreatPage />,
        path: "doingGreat",
      },
      {
        action,
        element: <CarsTimeSpentPage />,
        path: "timeSpent",
      },
      {
        action,
        element: <CarsMistakeCostPage />,
        path: "mistakeCost",
      },
      {
        action,
        element: <CarsBlockerPage />,
        path: "blocker",
      },
      {
        action,
        element: <CarsFutureOutcomePage />,
        path: "futureOutcome",
      },
      {
        action,
        element: <CarsSuccessSignalPage />,
        path: "successSignal",
      },
      {
        action,
        element: <CarsCommitmentPage />,
        path: "commitment",
      },
      {
        action,
        element: <SubscriptionCountPage />,
        path: "subscriptionCount",
      },
      {
        action,
        element: <CarsAlmostTherePage />,
        path: "almostThere",
      },
    ],
  },
]

export default onboardingCarsRoutes
